module.exports = __webpack_public_path__ + "static/img/vertex-component.f0532dcd.png";